// Lightweight intent helpers. The Contact form reads these from sessionStorage
// on mount, so CTAs across the site can pre-fill the right application context
// before navigating to /contact via React Router.

export const setIntent = (intent) => {
    try {
        if (intent) window.sessionStorage.setItem("indoblitz.intent", intent);
    } catch (e) {}
};

export const setProgrammeIntent = () => {
    try {
        window.sessionStorage.setItem("indoblitz.programme", "1");
    } catch (e) {}
};
